// Uploaded-file helpers: chunked upload + authenticated file URLs
import api from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;

export const fileUrl = (u) => {
  if (!u) return "";
  if (/^(https?:|data:|blob:)/.test(u)) return u;
  if (u.startsWith("/images/") || u.startsWith("/assets/")) return u;
  const token = localStorage.getItem("hrm_token") || "";
  const path = u.startsWith("/") ? u : `/${u}`;
  return `${process.env.REACT_APP_BACKEND_URL}${path}${path.includes("?") ? "&" : "?"}auth=${token}`;
};

export async function uploadFile(file, onProgress) {
  const { data: init } = await api.post("/admin/uploads/init", { filename: file.name, size: file.size });
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", init.upload_id);
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    await api.post("/admin/uploads/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await api.post("/admin/uploads/complete", {
    upload_id: init.upload_id, filename: file.name, content_type: file.type,
  });
  return data;
}

export const prettySize = (n = 0) =>
  n > 1048576 ? `${(n / 1048576).toFixed(1)} م.ب` : `${Math.max(1, Math.round(n / 1024))} ك.ب`;
